enum EstimationStatus {
    Null,
    New,
    Draft,
    Placed
}

export default EstimationStatus;



// WEBPACK FOOTER //
// ./src/domain/estimations/EstimationStatus.ts